import { createSlice } from "@reduxjs/toolkit";

export const departmentSlice = createSlice({
  name: "department",
  initialState: {
    getDepartmentResult: false,
    getDepartmentLoading: false,
    getDepartmentError: false,
    addDepartmentResult: false,
    addDepartmentLoading: false,
    deleteDepartmentResult: false,
  },
  reducers: {
    departmentReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_DEPARTMENT":
          return {
            ...state,
            getDepartmentResult: payload.data,
            getDepartmentLoading: payload.loading,
            getDepartmentError: payload.error,
          };
        case "ADD_DEPARTMENT":
          return {
            ...state,
            addDepartmentResult: payload.data,
            addDepartmentLoading: payload.loading,
          };
        case "DELETE_DEPARTMENT":
          return {
            ...state,
            deleteDepartmentResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { departmentReducers } = departmentSlice.actions;

export default departmentSlice.reducer;
